import { colors } from 'theme'

export const defaultThemeStyles = {
    deviceState: 'rgba(0, 0, 0, 0.7)',
    deviceStateText: colors.white,
    button: colors.white,
    imageContent: colors.blackLight,
    modalAccept: colors.darkCloud,
}
